import ForbiddenComponent from '../components/Exceptions/403';
import NoFoundComponent from '../components/Exceptions/404';
import ErrorComponent from '../components/Exceptions/500';
import LoginComponent from '../components/Login';
import QueryComponent from '../components/QueryComponent';
import UsersManage from '../components/UsersManage';
import VueRouter from 'vue-router'
import store from '../store';
import {getAuth, setAuth} from '../services/auth';


export const routeDefs = [
    {
        title: '查詢',
        show: true,
        claims: ['admin', 'super'],
        path: '/',
        name: 'query',
        exact: true,
        component: QueryComponent
    },
    {
        title: '使用者管理',
        show: true,
        claims: ['admin', 'super'],
        path: '/user',
        name: 'user',
        exact: true,
        component: UsersManage
    },
    {
        claims: [],
        path: '/login',
        component: LoginComponent,
        name: 'login'
    },
    {
        claims: [],
        path: '/403',
        component: ForbiddenComponent,
        name: 'forbidden'
    },
    {
        claims: [],
        path: '/404',
        component: NoFoundComponent,
        name: 'noFound'
    },
    {
        claims: [],
        path: '/500',
        component: ErrorComponent,
        name: 'error'
    },
    {
        path: '/sso',
        name: 'sso'
    },
    {
        path: '*'
    }
];

const router = new VueRouter({
    mode: 'history',
    routes: routeDefs,
});


router.beforeEach((to, from, next) => {
    const {path} = to.matched[0];
    if (path === '*') {
        next({name: 'noFound'});
    } else if (to.name === 'sso') {
        const {t} = to.query;
        if (t) {
            try {
                setAuth(window.atob(t));
                next('/');
            } catch {
                next({name: 'forbidden'});
            }
        } else {
            next({name: 'forbidden'});
        }
    } else {
        const {name} = to;
        const {claims} = getAuth();
        const authenticated = claims.length > 0;
        if (name === 'login') {
            if (authenticated) {
                next('/');
            } else {
                next();
            }
        } else {
            const def = routeDefs.find(r => r.name === name);

            if (authenticated || !def || def.claims.length <= 0) {
                if (def && def.claims.length > 0) {
                    //代表這個路徑允許這個登入者
                    if (def.claims.some(c => claims.some(cc => cc === c))) {
                        next();
                    } else {
                        store.commit('resetLoading');
                        //未授權
                        next({name: 'forbidden'})
                    }
                } else {
                    //不需要驗證的位址
                    if (def.name === 'forbidden' || def.name === 'error' || def.name === 'noFound') {
                        store.commit('resetLoading');
                    }
                    next();
                }

            } else {
                next({name: 'login', query: {redirect: name}});
            }
        }

    }

});

export default router;